import { i18nPrice } from '@shared/fondof-fn/format/price'
import { toProduct } from '@shared/shop-api/product/mapper'
import { toProductVariant } from '@shared/shop-api/product/variants/mapper'
import type { ProductWithVariantsFragment } from '@shared/types/storefront/graphql'

export const toProductWithVariants = (product: ProductWithVariantsFragment) => {
  const productUrl = `/p/${product.handle}`
  const productVariants = product.variants.items.map(toProductVariant)

  const variants = productVariants.map((variant) => ({
    ...variant,
    url: `${productUrl}?variant=${variant.id}`,
  }))

  const minVariantPrice = parseFloat(product.priceRange.minVariantPrice.amount)
  const maxVariantPrice = parseFloat(product.priceRange.maxVariantPrice.amount)
  const { currencyCode } = product.priceRange.minVariantPrice

  const hasVariantWithOffer = variants.some((variant) => variant.isOffer)
  const offeredVariants = variants.filter((variant) => variant.isOffer)
  const availableSizes = variants
    .map((variant) => variant.size)
    .filter((size): size is string => Boolean(size))

  const variantWithSize = variants.find(
    (variant) =>
      variant.size && variant.displaySize && variant.size !== 'One Size'
  )

  return {
    ...toProduct(product),
    variants,
    variantsCount: product.variantsCount?.count ?? variants.length,
    priceRange: {
      maxVariantPrice: product.priceRange.maxVariantPrice.amount,
      minVariantPrice: product.priceRange.minVariantPrice.amount,
      minPriceFormatted: i18nPrice(minVariantPrice, currencyCode),
      hasPriceRange: minVariantPrice !== maxVariantPrice,
      currencyCode,
    },
    hasVariantWithOffer,
    maxDiscount: hasVariantWithOffer
      ? Math.max(...offeredVariants.map((variant) => variant.discount))
      : 0,
    maxOriginalPriceFormatted: variants.reduce((max, variant) =>
      variant.originalPrice > max.originalPrice ? variant : max
    ).originalPriceFormatted,
    displaySize: variantWithSize?.displaySize,
    hasDisplayableSize: Boolean(variantWithSize),
    availableSizes,
  }
}
